export default "__VITE_ASSET__1fd1fb4b__"